





















































import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src

import Notifications from "vue-notification";

import { uuid } from 'vue-uuid';

Vue.use(Notifications);

@Component({
  data () {
      return {
        uuid: uuid.v1()
      }
  },
  components: {
    HelloWorld
  },
  methods: {
    show(group, type = "") {
      const text = `
        This is notification text!
        <br>
        Date: ${new Date()}
      `;
      this.$notify({
        group,
        title: `Test ${type} notification`,
        text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    }
  }
})
export default class Home extends Vue {}
